import { c as _c } from "react/compiler-runtime";
/**
 * HotboxCtaStrip — shared 3-card CTA block used at the bottom of 100+ raw CMS pages
 * (FAQ, Knowledge Base, Decoding, Installation Portal, etc.).
 *
 * Styles for the default `orange` variant were extracted from production
 * (https://www.getscw.com/support/faq/bitrate, 1440x900) and live in
 * HotboxCtaStrip.module.css.
 *
 * @example
 *   <HotboxCtaStrip config={STANDARD_HOTBOX} />
 *   <HotboxCtaStrip config={STANDARD_HOTBOX} variant="light-gray" />
 */

import { cn } from '@/lib/utils';
import type { HotboxCtaStripConfig, HotboxVariant } from './types';
import styles from './HotboxCtaStrip.module.css';
export interface HotboxCtaStripProps {
  config: HotboxCtaStripConfig;
  variant?: HotboxVariant;
  className?: string;
}
export function HotboxCtaStrip(t0) {
  const $ = _c(9);
  const {
    config,
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "orange" : t1;
  let t2;
  if ($[0] !== className || $[1] !== variant) {
    t2 = cn(styles.hotboxes, variantClass(variant), className);
    $[0] = className;
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = config.blockId;
  let t4;
  if ($[3] !== config.cards) {
    t4 = config.cards.map(_temp);
    $[3] = config.cards;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== config.blockId || $[6] !== t2 || $[7] !== t4) {
    t5 = <section className={t2} data-cms-block-id={t3}>{t4}</section>;
    $[5] = config.blockId;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp(card, index) {
  return <article className={styles.hotbox} key={card.title}><div className={styles.hotboxInner}><h3 className={styles.hotboxH3} data-cms-field={`cards.${index}.title`}>{card.title}</h3><p className={styles.hotboxP} data-cms-field={`cards.${index}.description`}>{card.description}</p><a href={card.href} className={styles.hotboxCta} data-cms-field={`cards.${index}.href`} aria-label={card.title} /></div></article>;
}
function variantClass(variant: HotboxVariant): string | undefined {
  switch (variant) {
    case 'orange':
      return styles.variantOrange;
    case 'light-gray':
      return styles.variantLightGray;
    case 'left-border':
      return styles.variantLeftBorder;
  }
}